import { Badge } from '@safetyhub/ui';

interface SectionTab {
  key: string;
  label: string;
  badge?: number;
}

interface SectionTabBarProps {
  tabs: SectionTab[];
  activeTab: string;
  onTabChange: (tabKey: string) => void;
  className?: string;
}

/**
 * 섹션 탭 바 컴포넌트
 * 탭 버튼만 렌더링하는 headless 컴포넌트 (콘텐츠 래퍼 없음)
 * 배경/패딩/그림자는 부모가 제어
 */
export function SectionTabBar({
  tabs,
  activeTab,
  onTabChange,
  className = '',
}: SectionTabBarProps) {
  return (
    <nav className={`flex border-b border-ink-200 ${className}`} role="tablist">
      {tabs.map((tab) => {
        const isActive = tab.key === activeTab;
        return (
          <button
            key={tab.key}
            role="tab"
            aria-selected={isActive}
            onClick={() => onTabChange(tab.key)}
            className={`
              flex-1 py-3 text-xs sm:text-sm lg:text-base font-medium border-b-2 transition-colors whitespace-nowrap
              ${
                isActive
                  ? 'border-brand-500 text-brand-600'
                  : 'border-transparent text-ink-500 hover:text-ink-700 hover:border-ink-300'
              }
            `}
          >
            {tab.label}
            {tab.badge !== undefined && tab.badge > 0 && (
              <Badge
                tone={isActive ? 'brand' : 'slate'}
                size="sm"
                className="ml-1.5 justify-center min-w-[22px] tabular-nums"
              >
                {tab.badge}
              </Badge>
            )}
          </button>
        );
      })}
    </nav>
  );
}
